<template>
  <span>
    <v-btn color="secondary" class="black--text" @click="modalOpened = true">
      <div class="text-btn">
        {{ $t('Pay') }}
      </div>
    </v-btn>

    <v-dialog :value="modalOpened"
              transition="dialog-bottom-transition"
              content-class="payment-information"
              @click:outside="clickedOutside">
      <template>
        <v-card>
          <div class="pa-5">
            <v-row v-if="!chat.paymentInformation.stripePublicKey && !chat.paymentInformation.stripePrivateKey && !chat.paymentInformation.iban">
              <v-col cols="12">
                <div>{{ $t('cat.nopaymentmethods') }}</div>
              </v-col>
            </v-row>
            <v-row v-if="!user || (chat.paymentInformation.stripePublicKey && chat.paymentInformation.stripePrivateKey)">
              <v-col cols="12">
                <div>{{ $t('Payment with stripe:') }}{{ amount }}</div>
                <PaymentComponent :amount="amount" :chat="chat" @success="onSuccessStripe()" @cancel="onCancelStripe" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div>{{ $t('Payment.crypto') }}</div>
                <form>
                  <v-btn :loading="loading" class="btn-primary" dark @click="payCrypto()">
                    {{ $t('Pay with crypto') }}
                  </v-btn>
                </form>
              </v-col>
            </v-row>
            <v-row v-if="user && chat.paymentInformation.iban">
              <v-col cols="12">
                <div>{{ $t('PaymentChatcomponent.Pay to ') + chat.paymentInformation.iban }}</div>
                <v-btn :loading="loading" style="margin: 10px 0" class="paymentInformation btn-primary" dark @click="payOutsidePlatform">
                  {{ $t('I payed outside of platform') }}
                </v-btn>
              </v-col>
            </v-row>
            <div style="display: flex; flex-direction: row-reverse;">
              <v-btn :loading="loading" text color="#FF6961" @click="modalOpened = false">
                {{ $t('Cancel') }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </span>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import PaymentComponent from "../components/Payment";
import {User} from "../models/user";
import Constants from "../../constants";
import SmartRepository from "@/repositories/SmartRepository";
export default {
    name: "PaymentChatComponent",
    components: {PaymentComponent},
    props: {
        chat: {type: Object, required: true},
        wantoPay: {type: Boolean, required: false}
    },
    data () {
        return {
            modalOpened: false,
            loading: false,
            status: "",
            cif: "",
            stripePublicKey: '',
            stripePrivateKey: '',
            publicAddress: '',
            iban: '',
            user: {},
            amount: 0,
            id: "",
        };
    },
    created () {
        this.amount = this.chat.factoring ? this.chat.factoring.formulaCalc.ACclc : this.chat.invoice.outstandingAmmount;
        if (this.wantoPay)
            this.openModal();
    },
    methods: {
        clickedOutside () {
            this.modalOpened = false;
        },
        openModal () {
            this.modalOpened = true;
        },
        saveForm () {
            this.modalOpened = true;
        },
        onSuccessStripe () {
            if (this.chat.factoring) {
                ApiRepository.payerPaymentToReceiverUpdate(this.chat.factoring._id, Constants.FACTORING.STATUS_ACCEPTED, "")
                    .then(async () => {
                        const rectInvoice = await ApiRepository.generateRectifyingInvoice(this.chat._id);
                     
                        const newCertification = await ApiRepository.generateNewCertification(this.chat._id);
                        const invoiceStamp = await ApiRepository.generateInvoiceStamp(this.chat._id);
                        ApiRepository.setInvoicePercentage('invoice_payed', this.chat.invoice._id).then(() => {
                            ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({
                                message: 'chat.byppayPayed',
                                extraMessage: 'chat.byppayPayedExtra',
                                params: {}
                            }), 'chat.byppayPayed').then(() => {
                            });
                            ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({
                                message: 'chat.invoiceGenerated',
                                extraMessage: 'chat.invoiceGeneratedExtra',
                                params: {user: rectInvoice.data.user}
                            }), 'chat.invoiceGenerated').then(async () => {
                                
                                if (rectInvoice) {
                                    await ApiRepository.getFilename(rectInvoice.data.invoice._id.toString()).then((res) => {
                                        ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", res.data.fileName).then(() => {
                                        });
                                    });
                                }
                                
                                if (newCertification) {
                                    await ApiRepository.getFilename(newCertification.data.invoice._id.toString()).then((res) => {
                                        ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", res.data.fileName).then(() => {
                                        });
                                    });
                                }
                                if (invoiceStamp != null) {
                                    ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", invoiceStamp.data.invoice.originalName).then(() => {
                                    });
                                    ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", invoiceStamp.data.invoicePayed.originalName).then(() => {
                                    });
                                }
                            });
                        });
                    });
            } else {
                ApiRepository.invoicePayed(this.chat.invoice._id)
                    .then(() => {
                        this.$emit('sendSystemHour');
                        ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({
                            message: 'chat.payed',
                            extraMessage: 'chat.payedExtra',
                            params: {user: (new User(this.$user)).getSingleName()}
                        }),  'chat.payed'
                        ).then(() => {
                            this.$emit('payed');
                            this.modalOpened = false;
                            ApiRepository.setInvoicePercentage('invoice_payed', this.chat.invoice._id).then(() => { });
                        });
                    })
                    .catch(() => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Error paying invoice'), color: "error"});
                    });
            }
        },
        onCancelStripe () {

        },
        payOutsidePlatform () {
            if (this.chat.factoring) {
                ApiRepository.payerPaymentToReceiverUpdate(this.chat.factoring._id, Constants.FACTORING.STATUS_PAYED, "", true)
                    .then(() => {
                        ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({message: 'chat.paymentOutsidePlatform', extraMessage: 'chat.paymentOutsidePlatformExtra', params: {user: (new User(this.$user)).getSingleName()}}),  'chat.paymentOutsidePlatform').then(() => { });
                    })
                    .catch((err) => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                    });
            } else {
                ApiRepository.invoicePayedOutsidePlatform(this.chat.invoice._id).then(() => {
                    this.$emit('sendSystemHour');
                    ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({
                        message: 'chat.paymentOutsidePlatform',
                        extraMessage: 'chat.paymentOutsidePlatformExtra',
                        params: {user: (new User(this.$user)).getSingleName()}
                    }),  'chat.paymentOutsidePlatform').then(() => {
                        this.message = "";
                    }).finally(() => {
                        this.$emit('payed');
                        this.modalOpened = false;
                    });
                }).catch((err) => {
                    console.log(err);
                    this.$root.$emit('show-snackbar', {
                        message: this.$t('Error changing the payment status'),
                        color: 'error'
                    });
                });
            }
        },
        async getWalletParameters () {
            return await ApiRepository.getPlatformAccounts();
        },
        async onSuccess (type, amountPayed, amountReceive) {
            await ApiRepository.addExchangeTransactionToUser(this.chat.invoice.receiver._id, type, amountPayed, amountReceive);
            this.$root.$emit('show-snackbar', {message: this.$t('Payed correctly')});
        },
        async payCrypto () {
            this.loading = true;
            const eurToByto = (await ApiRepository.getExangeRatios()).data.exangeRatios.eurToByto;
            let wallet = this.chat.paymentInformation.account;
            let createExchangeTransaction = false;
            if (!wallet) {
                wallet = (await this.getWalletParameters()).data.accounts.walletAddress;
                createExchangeTransaction = true;
            }
            const amountToPay = SmartRepository.parseEther(this.amount * eurToByto);

            SmartRepository.transaction(Constants.contractByto, "transfer", [wallet, amountToPay]).then(async () => {
                if (createExchangeTransaction) {
                    await this.onSuccess(Constants.FACTORING_PAYMENT_METHODS.CRYPTO, this.amount * eurToByto, this.amount);
                }
                this.$root.$emit('show-snackbar', {message: this.$t('Payed correctly')});
                this.onSuccessStripe();
            }).catch(async (err) => {
                console.log("ERROR: ");
                console.log(err);
                if (err.code === "UNSUPPORTED_OPERATION") {
                    this.$root.$emit('show-snackbar', {
                        message: this.$t('error.NoWallet'),
                        timeout: 50000,
                        url: 'https://youtu.be/4MDfryzYKcM',
                        textUrl: this.$t('error.NoWallet.Video'),
                        color: 'error'
                    });
                } else {
                    let amount = await SmartRepository.call(Constants.contractByto, "balanceOf", [SmartRepository.getMyAddress()]);
                    amount = parseInt(amount, 10);
                    if (amount < parseInt(amountToPay, 10)) {
                        this.$root.$emit('show-snackbar', {
                            message: this.$t('error.NoMoney'),
                            timeout: 50000,
                            url: Constants.BASE_URL + '/faucet',
                            textUrl: this.$t('error.NoMoney.Faucet'),
                            color: 'error'
                        });
                    } else {
                        this.$root.$emit('show-snackbar', {
                            message: this.$t('Error changing the payment status'),
                            color: 'error'
                        });
                    }
                }
            }).finally(() => {
                this.loading = false;
            });

        },
    }
};
</script>

<style scoped>
.divider{
    padding: 0 0 18px 0;
}
>>> .payment-information {
    align-self: flex-end;
}
>>> .v-text-field--outlined .v-label {
    top: 9px !important;
}
</style>
